import ChatThreadExchangeAssistantBlock from './ChatThreadExchangeAssistantBlock.jsx'

export default function ChatThreadExchangeAssistantSlot({
  assistant,
  exchangeId,
  query,
  nav,
  preamble,
  startSpeech,
  activeThreadId,
  onRegenerateAssistantVersion,
  onAgentQuestionSelect,
  isLastInConversation = false,
  focusedMessageId,
}) {
  if (!assistant.currentAssistant) return null
  return (
    <ChatThreadExchangeAssistantBlock
      currentAssistant={assistant.currentAssistant}
      exchangeId={exchangeId}
      activeAssistantVersionIndex={assistant.activeAssistantVersionIndex}
      activeQueryVersionIndex={query.activeQueryVersionIndex}
      answerActiveOrdinal={assistant.answerActiveOrdinal}
      answerCount={assistant.answerCount}
      answerCanPrev={assistant.answerCanPrev}
      answerCanNext={assistant.answerCanNext}
      onAnswerPrev={nav.onAnswerPrev}
      onAnswerNext={nav.onAnswerNext}
      preambleExpandedByAssistantId={preamble.preambleExpandedByAssistantId}
      togglePreambleExpanded={preamble.togglePreambleExpanded}
      startSpeech={startSpeech}
      activeThreadId={activeThreadId}
      onRegenerateAssistantVersion={onRegenerateAssistantVersion}
      onAgentQuestionSelect={onAgentQuestionSelect}
      isLastInConversation={isLastInConversation}
      focusedMessageId={focusedMessageId}
    />
  )
}
